import { Button, Stack, useTheme } from "@mui/material";
import React, { useState } from "react";
import { CustomTextField } from "../../../../../Components/StyledComponents/CustomTextField";
import { GppMaybe, Person, Search } from "@mui/icons-material";

export default function InputSection() {
  const theme = useTheme();

  const [filter, setFilter] = useState("coach");
  const [inp, setInp] = useState("");
  return (
    <Stack sx={{ gap: "1rem", justifyContent: "center" }} direction={{xs: "column-reverse" , lg:"row"}}>
      {/* Buttons */}
      <Stack sx={{ gap: "4px" , minHeight:"44px" , justifyContent:{xs:"center" , sm:"start"}}} direction={"row"}>
        <Button
          sx={{
            width: "100px",
            fontSize: ".8rem",
            transition: "all .5s",
            borderRadius: "14px",
            gap: "4px",
          }}
          variant={filter == "coach" ? "contained" : "outlined"}
          onClick={() => setFilter("coach")}
        >
          <Person fontSize="small" /> مربی
        </Button>
        <Button
          sx={{
            width: "100px",
            fontSize: ".8rem",
            transition: "all .5s",
            borderRadius: "14px",
            gap: "4px",
          }}
          variant={filter == "gym" ? "contained" : "outlined"}
          onClick={() => setFilter("gym")}
        >
          <GppMaybe fontSize="small" /> باشگاه
        </Button>
      </Stack>
      {/* Search Btn and Input */}
      <Stack sx={{ width: "100%", gap:{xs: ".5rem"  , sm: "1rem" }}} direction={"row"}>
        <CustomTextField
          onChange={(e) => {
            setInp(e.target.value);
          }}
          placeholder="سریع تر برس به چیزی که میخوای ..."
          sx={{
            width: "100%",
            color: theme.palette.text.contrastText,
            "& .MuiInputBase-input ": {
              fontSize: ".8rem",
              py: "12px",
            },
          }}
        />
        <Button
          color="primary"
          sx={{
            fontSize: ".8rem",
            transition: "all .5s",
            borderRadius: "14px",
            gap: "4px",
            minWidth:"0" ,
            px:"20px" ,
            py:"4px" , 
            ":disabled" : {
              bgcolor:"red !important"
            }
          }}
          // onClick={() => setFilter("coach")}
          variant="contained"
          disabled={inp?.length <= 0}
        >
          <Search
            sx={{
              transition: "all .3s",
              transform: inp?.length <= 0 ? "rotate(0deg)" : "rotate(450deg)",
            }}
            fontSize="small"
          />
        </Button>
      </Stack>
    </Stack>
  );
}
